import * as React from "react";
import { hot } from "react-hot-loader";
import CustomRouter from '../CustomRouter/CustomRouter';
declare var configcustoms: any;


class App extends React.Component<{}, {}> {

  constructor(props: any) {
    super(props);
  }

  public render() {

    return (
      <div id="app">
        <CustomRouter />
      </div>
    );
  }
}

export default hot(module)(App);
